import { UpdateType } from "@powersync/web";
/**
 * Bridges PowerSync's local CRUD queue to the ECT API (build plan step 4, PRD M14-04/05).
 * - fetchCredentials: GET /api/sync/credentials → PowerSync endpoint + short-lived token.
 * - uploadData: POST /api/sync/upload with the pending transaction; each op carries the client op id so
 *   replays are idempotent. Rejected ops are surfaced through `onRejected` (inline errors in the UI) and the
 *   transaction is completed: the server's state comes back on the next download.
 */
export class EctConnector {
    api;
    onRejected;
    constructor(api, onRejected) {
        this.api = api;
        this.onRejected = onRejected;
    }
    async fetchCredentials() {
        const res = await this.api.fetch("/api/sync/credentials");
        if (res.status === 401)
            return null;
        if (!res.ok)
            throw new Error(`credentials ${res.status}`);
        const json = (await res.json());
        return { endpoint: json.endpoint, token: json.token };
    }
    async uploadData(database) {
        const transaction = await database.getNextCrudTransaction();
        if (!transaction)
            return;
        const body = {
            device_id: this.api.deviceId,
            transactions: [{ tx_id: String(transaction.transactionId ?? transaction.crud[0]?.clientId ?? Date.now()), ops: transaction.crud.map(toOp) }],
        };
        const res = await this.api.fetch("/api/sync/upload", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(body) });
        if (!res.ok)
            throw new Error(`upload ${res.status}: ${await res.text()}`); // network/server error → PowerSync retries later
        const json = (await res.json());
        const rejected = json.transactions.flatMap((t) => t.ops).filter((o) => o.status === "rejected");
        if (rejected.length)
            this.onRejected?.(rejected);
        await transaction.complete();
    }
}
export function toOp(entry) {
    const op = entry.op === UpdateType.PUT ? "PUT" : entry.op === UpdateType.PATCH ? "PATCH" : "DELETE";
    const data = (entry.opData ?? {});
    return { op_id: String(entry.clientId), op, table: entry.table, id: entry.id, data, device_ts: typeof data.device_ts === "string" ? data.device_ts : undefined };
}
//# sourceMappingURL=connector.js.map